// extracted by mini-css-extract-plugin
module.exports = {"headerInputContainer":"CampaignNameInput_headerInputContainer__33oBM","close":"CampaignNameInput_close__39KTO"};